import { useCallback } from 'react';
import { InformationalScreen, ListCard, ListItem } from '@adc/parallax-component-library';
import { MainContainer, TopHeaderBackArrow } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { notifyApp } from 'Utilities/appCommunicator';

const consentsItems = [
  {
    text: 'Consents.microcopy.consentsOptions.healthcareCommunications',
    onPress: () => {
      mediator.publish('router:navigate', '/hipaa');
    },
  },
  {
    text: 'Consents.microcopy.consentsOptions.researchConsent',
    onPress: () => {
      mediator.publish('router:navigate', '/rwe');
    },
  },
] as const;

const ConsentsScreen = () => {
  const handleClickBack = useCallback(() => {
    mediator.publish('router:back');
    notifyApp('adc-webview:navigate-back-app');
  }, []);

  return (
    <MainContainer>
      <InformationalScreen
        topNavigationProps={{
          title: i18n.t('Consents.title'),
          buttonStart: {
            element: <TopHeaderBackArrow />,
            label: 'Consents.title-Pressable',
            onPress: handleClickBack,
          },
          testID: 'Consents.title',
        }}
      >
        <InformationalScreen.Page>
          <InformationalScreen.Content>
            <ListCard>
              {consentsItems.map((item, index) => (
                <ListItem key={index.toString()} title={i18n.t(item.text)} onPress={item.onPress} />
              ))}
            </ListCard>
          </InformationalScreen.Content>
        </InformationalScreen.Page>
      </InformationalScreen>
    </MainContainer>
  );
};

export default ConsentsScreen;
